module.exports = __webpack_public_path__ + "static/img/sfzz.e25d0df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spreader/sfzz.jpg
// module id = M3eX
// module chunks = 1